import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { enqueueSnackbar } from 'notistack';

import { useManageDigestReportModalStore } from './ManageDigestReportModalStore';

import useCreateDigestReport from 'hooks/DigestReports/useCreateDigestReport';

interface CreatePeriodReportModalProps {
  refetchPeriodReports: () => void;
}

const CreateDigestReportModal: FC<CreatePeriodReportModalProps> = ({ refetchPeriodReports }) => {
  const { createDigestReport } = useCreateDigestReport();
  const { slug, isOpen, onManageDigestReportModalClose } = useManageDigestReportModalStore();
  const { t } = useTranslation();

  const onCreateDigestReport = () => {
    createDigestReport(
      { slug: slug || '' },
      {
        onSuccess: () => {
          enqueueSnackbar('Digest report was created successfully', { variant: 'success' });
          refetchPeriodReports();
          onManageDigestReportModalClose();
        },
      },
    );
  };

  return (
    <Modal isOpen={isOpen} toggle={onManageDigestReportModalClose} size="md">
      <ModalHeader className="border-bottom pb-2 pt-3 " toggle={onManageDigestReportModalClose}>
        <div className="text-purple">Create Digest Report</div>
      </ModalHeader>
      <ModalBody>
        <div className="row m-2">
          <div className="col-md-12 d-flex align-items-center justify-content-center">
            <p>Are you sure you want to create a new digest report?</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="btn btn-ghost-danger"
          onClick={() => {
            onManageDigestReportModalClose();
          }}
        >
          {t('Modals.delete-modal.cancel')}
        </Button>{' '}
        <Button className="btn btn-ghost-success" onClick={() => onCreateDigestReport()}>
          Create report
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateDigestReportModal;
